module.exports = __webpack_public_path__ + "static/media/featured_image_2.3718c029.jpeg";